import { render } from "./DeleteTicketModal.vue?vue&type=template&id=0f284018&scoped=true"
import script from "./DeleteTicketModal.vue?vue&type=script&lang=js"
export * from "./DeleteTicketModal.vue?vue&type=script&lang=js"

import "./DeleteTicketModal.vue?vue&type=style&index=0&id=0f284018&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f284018"]])

export default __exports__